import { Tracker } from '@jarvis/tracker'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logProject = (window as any).ALIYUN_LOG_PROJECT as string
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logStore = (window as any).ALIYUN_LOG_STORE as string
const projectName = 'scp-cashier-fe'

export default new Tracker({
  logProject,
  logStore,
  projectName,
})
